<template>
  <div ref="containerRef" class="d-flex flex-row group-size-changes">
    <!-- <img alt="Shifts between Groups" src="../assets/sp2lnob/Group_Size_Changes.png" /> -->
    <UnescapChart v-if="chartData" :data="chartData"></UnescapChart>
  </div>
</template>

<script>

import UnescapChart from '@/components/UnescapChart.vue';
import { mapGetters } from 'vuex';

export default {
  name: 'GroupSizeChanges',
  components: {
    UnescapChart
  },
  props: {
    data: {
      type: Object,
      default: null
    }
  },
  data: function () {
    return {
      chartData: undefined
    };
  },
  mounted () {
    // this.initialize();
  },
  computed: {
    ...mapGetters('analysis', [
      'getSp2lnobConfigs'
    ])
  },
  watch: {
    data: {
      handler: function (data) {
        // console.log(data);
        const newNodes = [];
        const newLinks = [];
        let yLabel = '% Access';
        let uniqueCategories = [...new Set(data.map(d => d.category))].sort((a, b) => parseFloat(a) - parseFloat(b)).reverse();
        if (this.getSp2lnobConfigs.detailScenario1.outcome_variable_obj.type === 'negative') {
          uniqueCategories = uniqueCategories.reverse();
          yLabel = '% Prevalence';
        }
        const nodeColors = {};
        let idx = 0;
        const faColor = '#4979A6';
        const fbColor = '#FFAD80';
        const greyColors = ['#D4D4D4', '#C4C4C4', '#B4B4B4', '#A4A4A4', '#949494', '#848484', '#747474', '#646464', '#545454', '#444444'];
        for (const cate of uniqueCategories) {
          const nameText = Math.round(cate * 100) + '%';
          newNodes.push({ node: idx, name: nameText });
          newNodes.push({ node: idx + uniqueCategories.length, name: nameText });
          // const letters = '0123456789ABCDEF';
          // const color = '#';
          // for (let i = 0; i < 6; i++) {
          //   color += letters[Math.floor(Math.random() * 16)];
          // }
          // if (this.getSp2lnobConfigs.detailScenario1.outcome_variable_obj.type === 'negative') {
          //   nodeColors[nameText] = (idx === 0) ? fbColor : (idx === uniqueCategories.length - 1 ? faColor : greyColors[idx]);
          // } else {
          nodeColors[nameText] = (idx === 0) ? faColor : (idx === uniqueCategories.length - 1 ? fbColor : greyColors[uniqueCategories.length - idx - 2]);
          // }
          idx = idx + 1;
        }
        newNodes.sort((a, b) => a.node - b.node);
        for (const d of data) {
          if (d.axis === 'Simulated') {
            continue;
          }
          newLinks.push({ source: newNodes.map(n => n.name).indexOf(Math.round(d.pred_current_num * 100) + '%'), target: newNodes.map(n => n.name).lastIndexOf(Math.round(d.pred_simulated_num * 100) + '%'), value: d.n });
        }
        // console.log(newNodes);
        // console.log(newLinks);

        const width = this.$refs.containerRef.clientWidth;
        const sankeySetting = {
          data: { nodes: newNodes, links: newLinks },
          width: width,
          height: 500,
          yLabel: yLabel,
          margin: { top: 20, right: 0, bottom: 20, left: 0 },
          nodeWidth: 120,
          nodeColLabels: ['Without social protection', 'With social protection'],
          valueField: 'value',
          linkValueTemplate: '${value}',
          color: (name) => {
            return nodeColors[name];
          }
        };

        this.chartData = {
          type: 'sankey',
          setting: sankeySetting
        };
      }
    }
  },
  methods: {
    initialize: function () {
      const SANKEY_DATA = {
        nodes: [
          // { node: 0, name: 'node0' },
          // { node: 1, name: 'node1' },
          // { node: 2, name: 'node2' },
          // { node: 3, name: 'node3' }
          // { node: 4, name: "node4" }
        ],
        links: [
          // { source: 0, target: 2, value: 2 },
          // { source: 0, target: 3, value: 4 },
          // { source: 1, target: 2, value: 1 },
          // { source: 1, target: 3, value: 8 }
        ]
      };

      const sankeySetting = {
        data: SANKEY_DATA,
        width: 960,
        height: 500,
        margin: { top: 20, right: 0, bottom: 20, left: 0 },
        color: (name) => {
          if (name === 'node0') return '#3a659d';
          if (name === 'node1') return '#e06222';
          if (name === 'node2') return '#358ba5';
          if (name === 'node3') return '#b94745';
          // if (key === 'SOEA') return '#92b34f'
          return '#000';
        }
      };

      this.chartData = {
        type: 'sankey',
        setting: sankeySetting
      };
    }
  }
};
</script>

<style lang="css" scoped>
.group-size-changes img {
  width: 100%;
}
.group-size-changes .unescap-chart {
  margin: auto;
}
</style>
